import React from 'react';
import { Container } from 'react-bootstrap';

function About() {
  return (
    <Container id="about">
      <h2>Sobre</h2>
      <p>
        Rm Tripas é uma distribuidora localizada em Matias Barbosa, na região da Zona da Mata de Minas Gerais.  Oferecemos produtos diversos para açougues, mercados e para sua família.
        </p>
    </Container>
  );
}

export default About;
